<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-document-checked"></i> {{$t('pages.mtRealtimeList.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container" v-loading="loading">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-refresh" @click="getData">{{$t('pages.mtRealtimeList.refresh')}}</el-button>
                <el-button type="primary" icon="el-icon-printer" @click="printlist">{{$t('pages.mtStd.print')}}</el-button>
                <el-button type="success" icon="el-icon-takeaway-box" @click="exportlist">{{$t('pages.mtStd.export')}}</el-button>
            </div>
            <div class="handle-headright rt-time">
                {{ $t('pages.mtRealtimeList.dateCol') }}：{{ rtDate }}　{{ $t('pages.mtRealtimeList.timeColT') }}：{{ rtTime }}
            </div>
        </div>

        <!-- 整改清单第8项：按市县、集团公司、煤矿、出煤井、严重超产、系统工作异常查询（客户端过滤） -->
        <div class="filter-bar">
            <el-cascader v-model="query.region" :options="provinceOptions" class="mr10" clearable :placeholder="$t('pages.mtRealtimeList.regionPh')"></el-cascader>
            <el-cascader v-model="query.company" :options="deptTree" :props="{ checkStrictly: true }" class="mr10" clearable filterable :placeholder="$t('pages.mtRealtimeList.companyPh')"></el-cascader>
            <el-select v-model="query.mine" class="mine-select mr10" clearable filterable :placeholder="$t('pages.mtStd.mine')">
                <el-option v-for="item in mineOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-select v-model="query.shaft" class="mine-select mr10" clearable filterable :placeholder="$t('pages.mtRealtimeList.shaftPh')">
                <el-option v-for="item in shaftOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-switch v-model="query.severe" class="mr10" :active-text="$t('pages.mtRealtimeList.severeOnly')"></el-switch>
            <el-switch v-model="query.abnormal" :active-text="$t('pages.mtRealtimeList.abnormalOnly')"></el-switch>
        </div>

        <!-- MT1082-2008 5.5.4.2 表1 实时列表显示：日期及时间、煤矿、年/月/日生产能力（产量计划）、单位、
             当年/当月/当天产量、当天每班产量、系统工作状态及时刻、最后一次严重超产产量\产能比及时间 -->
        <el-table :data="displayRows" border class="table" id="mytable" header-cell-class-name="table-header" :height="tableHeight">
            <el-table-column type="index" :label="$t('pages.mtStd.index')" width="55" align="center"></el-table-column>
            <el-table-column prop="name" :label="$t('pages.mtStd.mine')" min-width="150"></el-table-column>
            <el-table-column prop="shaftName" :label="$t('pages.mtRealtimeList.shaftCol')" min-width="120"></el-table-column>
            <el-table-column prop="annualCapacity" :label="$t('pages.mtStd.annualCapacity')" width="100" align="center"></el-table-column>
            <el-table-column prop="monthCapacity" :label="$t('pages.mtStd.monthCapacity')" width="130" align="center"></el-table-column>
            <el-table-column prop="dayCapacity" :label="$t('pages.mtStd.dayCapacity')" width="130" align="center"></el-table-column>
            <el-table-column prop="unit" :label="$t('pages.mtStd.unit')" width="55" align="center"></el-table-column>
            <el-table-column prop="yearOutput" :label="$t('pages.mtStd.yearOutput')" width="90" align="center"></el-table-column>
            <el-table-column prop="monthOutput" :label="$t('pages.mtStd.monthOutput')" width="90" align="center"></el-table-column>
            <el-table-column prop="dayOutput" :label="$t('pages.mtStd.dayOutput')" width="90" align="center"></el-table-column>
            <el-table-column v-for="n in shiftCols" :key="'sh' + n" :label="shiftLabel(n)" min-width="90" align="center">
                <template slot-scope="scope">{{ shiftText(scope.row, n) }}</template>
            </el-table-column>
            <el-table-column :label="statusLabel()" min-width="170" align="center">
                <template slot-scope="scope">
                    <span :class="{ red: !scope.row.ok }">{{ statusText(scope.row) }}</span>
                </template>
            </el-table-column>
            <el-table-column :label="$t('pages.mtRealtimeList.lastSevere')" min-width="170" align="center">
                <template slot-scope="scope">
                    <span :class="{ red: !!scope.row.lastSevere }">{{ scope.row.lastSevere || '--' }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</div>
</template>

<script>
import {
    dateFormat,
    getchild,
    SortField,
    toTree
} from '../../utils/helper';
import {
    provinceAndCityData
} from 'element-china-area-data';
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'mtRealtimeList',
    data: function () {
        return {
            loading: false,
            tableHeight: window.innerHeight * 0.75,
            rows: [],
            rtDate: '--',
            rtTime: '--',
            provinceOptions: provinceAndCityData,
            balanceArr: [],
            mineMap: {},
            deptTree: [],
            query: {
                region: [],
                company: [],
                mine: '',
                shaft: '',
                severe: false,
                abnormal: false
            }
        };
    },
    computed: {
        // 当天每班产量：三班制固定3列，四班制按实际班次数增加（标准5.5.4.2）
        shiftCols() {
            var m = 0;
            this.displayRows.forEach((r) => {
                if (r.shifts && r.shifts.length > m) m = r.shifts.length;
            });
            return Math.max(3, m);
        },
        // 整改清单第8项：市县/集团公司/煤矿/出煤井/严重超产/系统工作异常多条件过滤
        displayRows() {
            var q = this.query;
            var mineName = (q.mine || '').toLowerCase();
            var shaft = (q.shaft || '').toLowerCase();
            var regionCode = q.region && q.region.length > 0 ? q.region[q.region.length - 1] : '';
            var deptId = q.company && q.company.length > 0 ? String(q.company[q.company.length - 1]) : '';
            return this.rows.filter((r) => {
                // 台账信息按 balanceId 实时关联，避免台账接口晚于实时数据返回时过滤字段为空
                var b = this.mineMap[r.balanceId] || {};
                if (mineName && (r.name || '').toLowerCase().indexOf(mineName) === -1) {
                    return false;
                }
                if (shaft && (r.shaftName || '').toLowerCase().indexOf(shaft) === -1) {
                    return false;
                }
                if (regionCode) {
                    var codes = (b.provinceCityCode || '').split('/');
                    var regionHit = codes.some((c) => {
                        if (!c) return false;
                        if (regionCode.slice(2, 4) !== '00') {
                            return c === regionCode; // 市级：精确匹配
                        }
                        return c.slice(0, 2) === regionCode.slice(0, 2); // 省级：省内任一市
                    });
                    if (!regionHit) {
                        return false;
                    }
                }
                if (deptId) {
                    var companyId = b.companyId == null ? '' : String(b.companyId);
                    var path = (b.parentIdPath || '').toString().split(',');
                    if (companyId !== deptId && path.indexOf(deptId) === -1) {
                        return false;
                    }
                }
                if (q.severe && !r.lastSevere) {
                    return false; // 严重超产：保留有严重超产（产能比>110%）记录的矿
                }
                if (q.abnormal && !r.bad) {
                    return false; // 系统工作异常：保留工作状态异常（通讯异常或存在进行中设备异常）的矿
                }
                return true;
            });
        },
        // 煤矿下拉：台账矿井名 + 主列表解析出的矿井名兜底（台账接口异常时查询仍有内容项）
        mineOptions() {
            var set = {};
            this.balanceArr.forEach((b) => {
                if (b.mineName) set[b.mineName] = true;
            });
            this.rows.forEach((r) => {
                if (r.name && r.name !== '--') set[r.name] = true;
            });
            return Object.keys(set);
        },
        // 出煤井下拉：台账设备名（剥"矿井:"前缀）+ 主列表解析出的设备名兜底
        shaftOptions() {
            var set = {};
            this.balanceArr.forEach((b) => {
                var s = (b.name || '').toString();
                var i = s.search('[::]');
                if (i > -1) {
                    s = s.substring(i + 1).trim();
                }
                if (s) set[s] = true;
            });
            this.rows.forEach((r) => {
                if (r.shaftName) set[r.shaftName] = true;
            });
            return Object.keys(set);
        }
    },
    created() {
        this.getBalanceList();
        this.getDept();
        this.getData();
    },
    mounted() {
        // 实时列表：30秒自动刷新
        this.timer = setInterval(() => {
            this.getData();
        }, 30 * 1000);
    },
    destroyed() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    methods: {
        getData() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.loading = true;
            this.$zybhttp
                .post('Business/GetIndexData', {
                    Field1: userInfo.userType,
                    Field2: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var list = (res.data.data && res.data.data.list) || [];
                        var yearMonth = dateFormat.formatDate(new Date(), 'yyyy-MM');
                        Promise.all(list.map((item) => this.enrichRow(item, yearMonth, userInfo))).then((rows) => {
                            this.loading = false;
                            this.rows = rows;
                            this.refreshTime();
                        });
                    } else {
                        this.loading = false;
                        this.$notify.error(res.message);
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.$notify.error(this.$t('pages.mtStd.fetchError'));
                });
        },
        // 整改清单第8项：拉取设备台账，为实时行补齐煤矿/出煤井/省市/集团公司过滤字段
        getBalanceList() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('Balance/GetList', {
                    Field1: userInfo.userType,
                    Field2: userInfo.id + '',
                    Field3: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list || [];
                        this.balanceArr = d;
                        var map = {};
                        d.forEach((b) => {
                            map[b.id] = b;
                        });
                        this.mineMap = map;
                    }
                })
                .catch(() => {});
        },
        // 集团公司树：与设备列表页同源（Dept/GetList）
        getDept() {
            this.$zybhttp
                .post('Dept/GetList', {
                    Field3: '1'
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        var userDept = parseInt(JSON.parse(window.localStorage.getItem('ms_userInfo')).deptId);
                        var newdata = getchild(d, [userDept], userDept);
                        d = d.filter((x) => newdata.indexOf(x.id) > -1);
                        d = d.sort(SortField('id', 'asc'));
                        var arr = [];
                        for (var i = 0; i < d.length; i++) {
                            arr.push({
                                id: d[i].id,
                                pid: d[i].parentId,
                                value: d[i].id,
                                label: d[i].name
                            });
                        }
                        this.deptTree = toTree(arr);
                    }
                })
                .catch(() => {});
        },
        // 单矿行补齐：当年/当月/当天产量与每班产量来自实时数据接口，
        // 年/月/日生产能力（产量计划）与最后一次严重超产产量\产能比\时间取自超产按月查询接口（当前月）
        enrichRow(item, yearMonth, userInfo) {
            var row = {
                name: item.FullName || '--',
                annualCapacity: '--',
                monthCapacity: '--',
                dayCapacity: '--',
                unit: this.$t('pages.mtStd.unitT'),
                yearOutput: this.nz(item.yearProduction),
                monthOutput: this.nz(item.monthProduction),
                dayOutput: this.nz(item.dayProduction),
                shifts: (item.Data || []).map((d) => ({
                    label: d.name,
                    weight: d.freWeight
                })),
                ok: this.isConnectOk(item.Connect),
                status: this.isConnectOk(item.Connect) ? this.$t('pages.mtRealtimeList.statusNormal') : this.$t('pages.mtRealtimeList.statusAbnormal'),
                statusTime: item.starTime || '--',
                lastSevere: '',
                ongoing: [],
                ongoingTime: '',
                bad: false
            };
            // FullName 后端格式："矿井:xxx,     设备名称:yyy"（自定义标题样式无固定格式，拆不出则整体作矿名）
            var parsed = this.parseFullName(item.FullName);
            row.name = parsed.mine;
            row.shaftName = parsed.shaft;
            row.balanceId = item.BalanceId;
            // 系统工作异常：除通讯状态外，结合 EquStateReport 进行中的异常（通讯中断/外壳打开/供电异常/参数状态/计量异常/输煤能力低）
            var stateReq = item.BalanceId
                ? this.$zybhttp
                      .get('Business/EquStateReport', {
                          params: { balanceId: item.BalanceId }
                      })
                      .then((res) => {
                          if (res.data.status == 0) {
                              var types = (res.data.data && res.data.data.types) || [];
                              types.forEach((t) => {
                                  (t.records || []).forEach((r) => {
                                      if (r.ongoing) {
                                          row.ongoing.push(t.stateType);
                                          if (!row.ongoingTime || (r.startTime || '') < row.ongoingTime) {
                                              row.ongoingTime = r.startTime || ''; // 异常时刻取最早开始的一次
                                          }
                                      }
                                  });
                              });
                          }
                      })
                      .catch(() => {})
                : Promise.resolve();
            var ccReq = this.$zybhttp
                .post('OverproductionQuery/MonthCCData', {
                    YearMonth: yearMonth,
                    balanceId: item.BalanceId,
                    CreateUserId: userInfo.id,
                    UserName: userInfo.realName
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        row.annualCapacity = this.nz(res.data.info1);
                        row.monthCapacity = this.nz(res.data.info2);
                        row.dayCapacity = this.nz(res.data.info3);
                        var events = ((res.data.data && res.data.data.list) || [])
                            .filter((it) => this.isSevereCnb(it.dayCNB))
                            .sort((a, b) => this.dayTime(b) - this.dayTime(a));
                        if (events.length > 0) {
                            var ev = events[0]; // 最后一次严重超产：产能比大于110%的事件中日期最大者
                            row.lastSevere = this.nz(ev.weight) + '\\' + this.fmtCnb(ev.dayCNB) + '\\' + this.fmtDay(ev.overproductionDate || ev.date);
                        }
                    }
                })
                .catch(() => {});
            return Promise.all([ccReq, stateReq]).then(() => {
                row.bad = !row.ok || row.ongoing.length > 0; // 工作异常=通讯异常或存在进行中设备异常
                return row;
            });
        },
        refreshTime() {
            var now = new Date();
            this.rtDate = dateFormat.formatDate(now, 'yyyy-MM-dd');
            this.rtTime = dateFormat.formatDate(now, 'hh:mm');
        },
        shiftLabel(n) {
            return this.$t('pages.mtStd.nth') + n + this.$t('pages.mtRealtimeList.shiftOutput');
        },
        shiftText(row, n) {
            var sh = row.shifts && row.shifts[n - 1];
            return sh ? this.nz(sh.weight) : '--';
        },
        statusLabel() {
            return this.$t('pages.mtStd.status') + '\\' + this.$t('pages.mtStd.timeCol');
        },
        statusText(row) {
            if (row.ongoing && row.ongoing.length > 0) {
                // 表1"系统工作状态及时刻"：进行中异常优先显示异常类型与异常时刻
                return row.ongoing.join('、') + '\\' + this.nz(row.ongoingTime || row.statusTime);
            }
            return row.status + '\\' + row.statusTime;
        },
        isConnectOk(val) {
            const s = (val || '').toString();
            if (s === '连接成功' || s === '已连接') return true;
            return /成功|connected|success/i.test(s);
        },
        // 拆解 FullName："矿井:xxx, 设备名称:yyy" → 煤矿/出煤井（兼容中英文冒号、逗号）
        parseFullName(full) {
            var s = (full || '').toString().trim();
            var m = s.match(/矿井[::]\s*([^,,，，]+)/);
            var d = s.match(/设备名称[::]\s*([^,,，，]+)/);
            if (m || d) {
                return {
                    mine: m ? m[1].trim() : s,
                    shaft: d ? d[1].trim() : ''
                };
            }
            return { mine: s, shaft: '' };
        },
        // CNB 归一化为比率：数值>10 视为百分数（110→1.1），<=10 视为小数比率（1.1→1.1），含%字符串除以100
        parseCnbToRatio(v) {
            if (v === null || v === undefined || v === '') return null;
            var s = String(v).trim();
            if (s.indexOf('%') > -1) {
                var n = parseFloat(s.replace('%', ''));
                return isFinite(n) ? n / 100 : null;
            }
            var n2 = parseFloat(s);
            if (!isFinite(n2)) return null;
            return n2 > 10 ? n2 / 100 : n2;
        },
        isSevereCnb(v) {
            var r = this.parseCnbToRatio(v);
            return r !== null && r > 1.1; // 产能比超过110%为严重超产
        },
        fmtCnb(v) {
            if (v === null || v === undefined || v === '') return '--';
            var s = String(v).trim();
            if (s.indexOf('%') > -1) {
                var pv = parseFloat(s.replace('%', ''));
                return isFinite(pv) ? this.oneDecimal(pv) + '%' : '--';
            }
            var n = parseFloat(s);
            if (!isFinite(n)) return '--';
            var p = n > 10 ? n : n * 100;
            return this.oneDecimal(p) + '%';
        },
        oneDecimal(p) {
            var r = Math.round(p * 10) / 10;
            return Number.isInteger(r) ? r.toFixed(0) : r.toFixed(1);
        },
        nz(v) {
            return v === null || v === undefined || v === '' ? '--' : v;
        },
        dayTime(it) {
            var s = String(it.overproductionDate || it.date || '');
            var t = new Date(s.substring(0, 10)).getTime();
            return isNaN(t) ? 0 : t;
        },
        fmtDay(v) {
            if (!v) return '--';
            var s = String(v);
            return s.length > 10 ? s.substring(0, 10) : s;
        },
        printlist() {
            var props = [{
                    field: 'index',
                    displayName: this.$t('pages.mtStd.index'),
                    columnSize: '4%'
                },
                {
                    field: 'name',
                    displayName: this.$t('pages.mtStd.mine'),
                    columnSize: '10%'
                },
                {
                    field: 'annualCapacity',
                    displayName: this.$t('pages.mtStd.annualCapacity'),
                    columnSize: '6%'
                },
                {
                    field: 'monthCapacity',
                    displayName: this.$t('pages.mtStd.monthCapacity'),
                    columnSize: '7%'
                },
                {
                    field: 'dayCapacity',
                    displayName: this.$t('pages.mtStd.dayCapacity'),
                    columnSize: '7%'
                },
                {
                    field: 'unit',
                    displayName: this.$t('pages.mtStd.unit'),
                    columnSize: '3%'
                },
                {
                    field: 'yearOutput',
                    displayName: this.$t('pages.mtStd.yearOutput'),
                    columnSize: '6%'
                },
                {
                    field: 'monthOutput',
                    displayName: this.$t('pages.mtStd.monthOutput'),
                    columnSize: '6%'
                },
                {
                    field: 'dayOutput',
                    displayName: this.$t('pages.mtStd.dayOutput'),
                    columnSize: '6%'
                }
            ];
            var data = this.rows.map((r, i) => {
                var o = {
                    index: i + 1,
                    name: r.name,
                    shaft: r.shaftName || '--',
                    annualCapacity: r.annualCapacity,
                    monthCapacity: r.monthCapacity,
                    dayCapacity: r.dayCapacity,
                    unit: r.unit,
                    yearOutput: r.yearOutput,
                    monthOutput: r.monthOutput,
                    dayOutput: r.dayOutput,
                    status: this.statusText(r),
                    lastSevere: r.lastSevere || '--'
                };
                for (var n = 1; n <= this.shiftCols; n++) {
                    o['sh' + n] = this.shiftText(r, n);
                    props.push({
                        field: 'sh' + n,
                        displayName: this.shiftLabel(n),
                        columnSize: '6%'
                    });
                }
                props.push({
                    field: 'status',
                    displayName: this.statusLabel(),
                    columnSize: '12%'
                });
                props.push({
                    field: 'lastSevere',
                    displayName: this.$t('pages.mtRealtimeList.lastSevere'),
                    columnSize: '12%'
                });
                return o;
            });
            print({
                printable: data,
                header: `<div style="display: flex;flex-direction: column;text-align: center"><h3>${this.$t('pages.mtRealtimeList.printTitle')}（${this.$t('pages.mtRealtimeList.dateCol')}：${this.rtDate}　${this.$t('pages.mtRealtimeList.timeColT')}：${this.rtTime}）</h3></div>`,
                properties: props,
                type: 'json',
                gridHeaderStyle: 'border: 1px solid #000;text-align:center;padding:6px;0px;',
                gridStyle: 'border: 1px solid #000;text-align:left;padding:5px;10px;'
            });
        },
        exportlist() {
            let date = new Date();
            let name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
            var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                FileSaver.saveAs(new Blob([wbout], {
                    type: 'application/octet-stream'
                }), this.$t('pages.mtRealtimeList.printTitle') + name + '.xlsx');
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout);
            }
            return wbout;
        }
    }
};
</script>

<style scoped>
.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.rt-time {
    line-height: 40px;
    font-weight: bold;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.filter-bar {
    clear: both;
    margin-bottom: 15px;
}

.mine-select {
    width: 150px;
}
</style>
